import { Component, OnInit, OnDestroy, NgZone, ViewChild } from "@angular/core";

import { ModalDirective } from "ngx-bootstrap/modal";

import { Subscription } from "rxjs";

import {
  AuthorizationService,
  LanguageService,
  ToastrService,
  Language,
  LanguageDetail,
} from "./../../../shared/index";
//import { CatalogService } from "./../../index";

@Component({
  selector: "languagepack-index",
  templateUrl: "./languagepack-index.html",
  standalone: false,
})
export class LanguagePackIndexComponent implements OnInit, OnDestroy {
  @ViewChild("uploadPackModal") modal: ModalDirective;
  public languages: Language[] = [];
  public pack: Language = new Language();

  public filename: string;
  private files: File[];

  private subscriptions: Subscription[] = [];

  constructor(
    private _ngZone: NgZone,
    private _authorizationService: AuthorizationService,
    private _languageService: LanguageService,
    private _toastrService: ToastrService
  ) {
    this.subscriptions.push(
      this._languageService.lagnuagesChange.subscribe(
        (languages: Language[]) => {
          this._ngZone.run(() => {
            this.languages = languages;
          });
        }
      )
    );

    this.subscriptions.push(
      this._languageService.languageDetailChange.subscribe(
        (languageDetail: LanguageDetail) => {
          this._ngZone.run(() => {
            this.languages.filter(
              (value) => value.Part == languageDetail.Name
            )[0].Detail = languageDetail;
          });
        }
      )
    );
  }

  public getLink(language: Language): string {
    if (language.Detail) {
      return (
        window.document.location.origin +
        "/api/Manuals/LanguagePack?packName=" +
        language.Part
      );
    } else {
      return (
        window.document.location.origin +
        "/api/Manuals/LanguagePack?packName=DEFAULT"
      );
    }
  }

  public close(): void {
    this.modal.hide();
    this.files = [];
    this.filename = "";
  }

  public upload(language: Language): void {
    this.pack = language;
    this.modal.show();
  }

  public preUpload(event: any): void {
    this.files = event.srcElement.files;
    this.filename = this.files[0].name;
  }

  public uploadFile(): void {
    this.modal.hide();

    const formData: FormData = new FormData(),
      xhr: XMLHttpRequest = new XMLHttpRequest();
    formData.append("languageName", this.pack.Part);

    for (let i = 0; i < this.files.length; i++) {
      formData.append("uploads[]", this.files[i], this.files[i].name);
    }

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          const response: any = JSON.parse(xhr.response);
          if (response.status == "Error") {
            this._toastrService.displayToastrMessage(
              "error",
              "Language pack upload failed for " +
                this.pack.Value +
                "!  Error: " +
                response.error,
              "Language Pack Upload"
            );
          } else {
            this._toastrService.displayToastrMessage(
              "success",
              "Language pack uploaded for " + this.pack.Value + "!",
              "Language Pack Upload"
            );
          }
        }
      }
    };

    xhr.open(
      "POST",
      window.document.location.origin + "/api/Manuals/UploadLanguage",
      false
    );
    xhr.send(formData);
    this.ngOnInit();
  }

  ngOnInit(): void {
    this._languageService.getSections();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
